import { Link } from "react-router-dom";

const FooterLink = ({ to, children }: { to: string; children: React.ReactNode }) => {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Link to={to} onClick={handleClick}>
      {children}
    </Link>
  );
};

export default FooterLink;